import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';

import { concatMap, switchMap, map, catchError } from 'rxjs/operators';

import * as FacilityAllocationActions from './facility-allocation.actions';
import { AccountAllocationsService } from '../account-allocations.service';
import * as fromShared from '../../../shared';
import { DisplayMessageMinimum, ResponseStatus } from '../../../shared';

@Injectable()
export class FacilityAllocationEffects {
    getFacilityAllocations$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FacilityAllocationActions.getFacilityAllocations),
            switchMap(() =>
                this.service.getFacilityAllocations().pipe(
                    map(data =>
                        FacilityAllocationActions.loadFacilityAllocations({
                            facilityAllocations: data
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });

    putFacilityAllocations$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FacilityAllocationActions.putFacilityAllocations),
            switchMap(action =>
                this.service
                    .putFacilityAllocations(action.facilityAllocations)
                    .pipe(
                        concatMap(resp =>
                            fromShared.Errors.IsSuccessStatus(resp.StatusCode)
                                ? [
                                      FacilityAllocationActions.upsertFacilityAllocations(
                                          {
                                              facilityAllocations: resp.Items
                                          }
                                      ),
                                      new fromShared.Errors.RemoveErrors(
                                          resp.Items.filter(
                                              x =>
                                                  x.Status.StatusCode ===
                                                  ResponseStatus.Success
                                          ).map(x => x.id.toString())
                                      ),
                                      new fromShared.Errors.SetErrors(
                                          fromShared.Errors.MapErrorsToStatus(
                                              resp
                                          )
                                      )
                                  ]
                                : [
                                      new fromShared.Errors.SetErrors(
                                          fromShared.Errors.MapErrorsToStatus(
                                              resp
                                          )
                                      ),
                                      FacilityAllocationActions.upsertFacilityAllocations(
                                          {
                                              facilityAllocations: resp.Items
                                          }
                                      )
                                  ]
                        ),
                        catchError(fromShared.Errors.handleServiceError)
                    )
            )
        );
    });
    getFacilityAllocationTypes$ = createEffect(() => {
        return this.actions$.pipe(
            ofType(FacilityAllocationActions.getFacilityAllocationTypes),
            switchMap(() =>
                this.service.getFacilityAllocationTypes().pipe(
                    map(data =>
                        FacilityAllocationActions.loadFacilityAllocationTypes({
                            facilityAllocationTypes: data
                        })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        );
    });
    constructor(
        private actions$: Actions,
        private service: AccountAllocationsService
    ) {}
}
